import React from "react";
import EachAddOffering from "./EachAddOffering";

function AddOfferings({
  allServices,
  partners,
  data,
  addMore,
  removeOffering,
  updateData
}) {
  return (
    <div>
      {data?.map((ele, idx) => {
        return (
          <EachAddOffering
            allServices={allServices}
            partners={partners}
            updateData={updateData}
            data={ele}
            index={idx}
            removeOffering={removeOffering}
          />
        );
      })}
      <div className="d-flex">
        <div
          onClick={addMore}
          className="btn-danger rounded p-1 px-2 mt-2 fs-6 cursor-pointer"
        >
          Add More
        </div>
      </div>
    </div>
  );
}

export default AddOfferings;
